import {DotPath} from '../getOrElse'
import {getDefinedOrElse} from './getter'
import {Decorators} from '../config/getterConfig'
import {decorate} from './decorator'

export function stringOr<R extends any, T extends string>(
  root: R,
  path: DotPath = '',
  decorators: Decorators<T> = [],
  orElse = '' as T
): T {
  const decorated = decorate(
    getDefinedOrElse(root, path, orElse),
    decorators
  )
  return [].concat(decorated).map(possibleString =>
      (typeof possibleString === 'object') ?
        JSON.stringify(possibleString) :
        String(possibleString)
  ).shift() as T
}